
export class RuntimeError extends Error {

    /** The cause error. */
    private cause: object;

    constructor(message: string, cause?: object) {
        super(message);
        this.name = 'RuntimeError';
        this.cause = cause;
    }
}